exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tracker-info[data-v-e57e93d6]{min-height:2rem;max-height:6rem}i.anticon[data-v-e57e93d6]{height:1rem}.view-trackers[data-v-e57e93d6]{text-decoration:none;color:#fff}", ""]);

// exports
